import React from 'react';

/** Flat enterprise surface: background + 1px border. Never nest cards. */
const Card = ({ children, className = '', hover = false, as: Tag = 'div', ...props }) => (
    <Tag className={`card ${hover ? 'card-hover' : ''} ${className}`} {...props}>
        {children}
    </Tag>
);

export const CardHeader = ({ title, subtitle, actions, children, className = '' }) => (
    <div className={`card-header ${className}`}>
        {children || (
            <div className="min-w-0">
                <h2 className="card-title truncate">{title}</h2>
                {subtitle && <p className="text-micro text-muted mt-0.5">{subtitle}</p>}
            </div>
        )}
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
);

export const CardBody = ({ children, className = '', padded = true }) => (
    <div className={`${padded ? 'card-body' : ''} ${className}`}>{children}</div>
);

export const CardFooter = ({ children, className = '' }) => (
    <div className={`card-footer ${className}`}>{children}</div>
);

export default Card;
